export const AD_TRACKING_CONSENT_EVENT_PROPERTY = 'ad_tracking_consent';
